import { render, staticRenderFns } from "./ProdutorFazendaForm.vue?vue&type=template&id=54f31450"
import script from "./ProdutorFazendaForm.vue?vue&type=script&lang=js"
export * from "./ProdutorFazendaForm.vue?vue&type=script&lang=js"
import style0 from "./ProdutorFazendaForm.vue?vue&type=style&index=0&id=54f31450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports